import styled from "@emotion/styled";
import { Box, IconButton, Typography } from "@mui/material";
import theme from "../../../theme";
import { HEADER_AND_TAB_HEIGHT } from "../../ChatInfo.style";

export const VitalsContainer = styled(Box)`
  max-height: calc(100dvh - ${HEADER_AND_TAB_HEIGHT}px);
  overflow: auto;
  padding: 24px;
`;

export const ActionsContainer = styled(Box)`
  display: flex;
`;

export const Header = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  gap: 4px;
`;

export const Title = styled(Typography)`
  color: ${theme.palette.text.secondary};
`;

export const VitalsIconButton = styled(IconButton)``;

export const LoaderContainer = styled(Box)`
  display: flex;
  width: 40px;
  justify-content: center;
`;

export const DeviceInfoWrapper = styled(Box)`
  padding: 24px;
`;

export const DeviceWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
  cursor: pointer;
`;

export const DeviceName = styled(Typography)`
  font-size: 15px;
`;

export const SeeReadingsMessage = styled(Typography)`
  font-size: 14px;
`;

export const DeviceContainer = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
`;
